import { Base } from '../Base';
export class EquipmentInfo extends Base {
    EquipmentID?: number;
    locationName?: string;
    ModelID?: number;
    EquipmentSerialNumber?: string;
    DateOfOriginalInstall?: string;
    DateOfLastRepair?: string;
    lastClockHours?: number;
    clockhours?: number;
    DateWarrantyExpires?: string;
    DateOfLastPM?: string;
    isCustomScheduleActiveFlag?: boolean;
    ModelDescription?: string;
    modelNumber?: string;
    EquipmentTypeID?: number;
    EquipmentSubTypeID?: number;
    ManufacturerID?: number;
    hasClock?: string;
    hasClockText?: string;
    ManufacturerName?: string;
    EquipmentTypeDescription?: string;
    EquipmentSubTypeDescription?: string;
    modifiedby?: number;
    equipmentDescription?: string;
    status?: string;
    equipmentstatusid?: number;
    electricalLeakageMax?: string;
    groundWireResistanceMax?: string;
    facilityName?:string;
    MPI?:string;
    ConfirmMPI?:string;
    DateModified:string;
    modalityDescription?:string;  
    equipmentOrigin?:string;
    equipmentCondition?:string;
    equipmentConditionId?:number;
    equipmentOriginId?:number;
    facilityMasterid?:number;
    LocationDescription?:string;
    locationtypeid?:number;
    equipmentModalityId?:number;
    OverrideReason?:string;
    MachineIPAddress?:string;
    MachineNickName?:string;
    IsIpAddressEnabled?: boolean;
    IsNickNameEnabled?:boolean

}
export class EquipmentInfoResponse extends Base {
    response?: Array<EquipmentInfo>;
    constructor() {
        super();
    }
}
export class EuqipmentHistoryData extends Base {
    FacilityName?: number;
    DateLocationChanged?: string;
    LocationTypeDesc?: number;
    EquipmentStatusDescription?: string;
    ModifiedBy:string;
    FullName?:string;

}
export class EuqipmentHistoryDataResponse extends Base {
    response?: Array<EuqipmentHistoryData>;
    constructor() {
        super();
    }
}
export class MPI{
EquipmentID?:string;
EquipPatientID?:string
MPI?:string;
ConfirmMPI:string;
StartDate?:string
EndDate ?:string
}

export class SelectedData{

    ActuatorVersion?:string;
    FunctionalVersion?:string;
    MachineIPAddress?:string;
    MachineNickName?:string;
    dateOfOriginalInstall?:string;
    dateWarrantyExpires?:string;
    equipmentConditionId
    equipmentdescription?:string;
    equipmentId?:number;
    equipmentOriginId?:number;
    equipmentModalityId?:number;
    equipmentserialnumber?:number;
    equipmentstatusid?:number;
    isCustomScheduleActiveFlag?:boolean;
    isPMScheduleActiveFlag?:boolean;
    lastClockHours?:number;
    modelId?:number;
    userid?:number;
    EquipmentTypeDescription:string;
    EquipmentSubTypeDescription:string;
    ManufacturerName:string;
    ModelDescription:string;
    GeneralSoftwareVersion:string;
    OverrideReason:string;
    status:string;
    ManufacturerID:string;
    modalityDescription:string;
    equipmentOrigin:string;
    modifiedby:string;
    DateOfLastPM:string;
    DateOfLastRepair:string;
    clockhours:string;
    fullname:string;
    equipmentCondition:string;
    CurrentMachineNickName?: string;
    CurrentMachineIPAddress?: string;
    CurrentActuatorVersion?:string;
    CurrentFunctionalVersion?:string;
    CurrentGeneralSoftwareVersion:string;
}
export class FacilityEuipment {
    Manufacture;
    Model;
    SNIntID;
    MPI;
    Facility;
    EquipYype;
    SubType;
    Status;
    EquipmentDescription
  }
  export class SelectedEquipmentInfo{
    EquipmentID;
    ManufacturerName;
    modelNumber;
    EquipmentSerialNumber;
    MPI;
    EquipType;
    status;
    NewStatus;
  }
  export class EquipmentStatusInfo {
    public equipmentid?: number;
    public locationtypeid?: number;
    public datemodified?: string;
    public userid?: number;
    public equipmentstatusid?: number;
    public locationdescription?: string;
    public facilitymasterid?: number;
  }
  export class EquipmentType 
  {  
    EquipmentTypeId: number;
    EquipmentTypeDescription: string;
  }